import axios from "axios";

export const Client = axios.create({
  baseURL: "http://sdsai.ephhk.com/api",
  responseType: "json",
});
